import GetAsspAd from "@/components/adver/index"
const { getOdinData } = require("@/request/odinRequest")
const { articleAdConfig } = require("@/config/adConfig")

module.exports = {
    init: function (opts, deps) {
        if (!opts.showAd) return
        const that = this
        this.opts = opts
        this.deps = deps
        this.thresholds = []
        this.ifModel = true
        // 特殊hack逻辑：主要用来给广告组件传递必要的上报参数
        window.sohuInfo = {
            newsid: opts.news_id,
            subid: opts.media_id,
            channelid: opts.channel_id,
        }
        that.load(opts)
    },
    load: function (opts) {
        const keywords = opts.keywords?.replace(/\[|\]/g, "")?.split(",") || []
        const context = keywords?.length > 0 && {
            adKeywords: keywords?.slice(0, 6)?.join("")
        }
        articleAdConfig && Object.values(articleAdConfig).forEach(async (adConfig) => {
            const { posCode, rule, fixArray, resourceId, spmCCode, el } = adConfig
            const requestParam = {
                adInfo: {
                    posCode,
                    rule,
                    fixArray
                },
                isSingleAd: true,
                resourceId,
                spmCCode
            }
            context && ( requestParam.context = context)
            try {
                const data = await getOdinData(requestParam)
                const list = data?.list
                list?.forEach(item => {
                    const renderParam = {
                        data: item?.resourceData,
                        el: document.querySelector(el),
                        spmCode: `${spmCCode}.1`,
                        resourceId: resourceId,
                    }
                    GetAsspAd(renderParam)
                })
            } catch (error) {
                console.log(el,spmCCode,'广告加载或者渲染失败', error)
            }
        })
    },
}
